import "./styles/index.css";
import { makeArt } from "./art/cast";
import { initCall } from "./engine/call";
import { initCamera } from "./engine/camera";
import { initDebrief } from "./engine/debrief";
import { closeDialog, openDialog } from "./engine/dialog";
import { initDrawer } from "./engine/drawer";
import { registerDepartments } from "./engine/flow";
import { initHelp } from "./engine/help";
import { sendText } from "./engine/llm";
import { initPlayerInput, triggerInteract } from "./engine/player";
import { startRenderLoop } from "./engine/render";
import { rt, S } from "./engine/state";
import { spend, startIdleClock } from "./engine/time";
import { initTouchPad } from "./engine/touchpad";
import { interact } from "./engine/world";
import { closeZoom, initZoom } from "./engine/zoom";
import { DEPARTMENTS } from "./levels";
import { applyStaticText } from "./i18n";
import { $, isImeComposing } from "./lib/dom";
import { initTitle } from "./title";

function initComposer(): void {
  $("#sendBtn").onclick = () => void sendText();
  $<HTMLTextAreaElement>("#input").addEventListener("keydown", (e) => {
    if (isImeComposing(e)) return;
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      void sendText();
    }
  });
  // Clicking the log skips the typewriter animation.
  $("#log").addEventListener("click", () => {
    rt.fastForward = true;
  });
}

applyStaticText();
makeArt();
registerDepartments(DEPARTMENTS);
initZoom();
initCall();
initDebrief();
initHelp();
initPlayerInput();
initTouchPad();
initCamera();
initDrawer();
initComposer();
startIdleClock();
startRenderLoop();
initTitle(DEPARTMENTS);

// Test hook for e2e: fast-forward the game clock, walk every interaction. Stripped from production builds.
if (import.meta.env.DEV) {
  const interactIds = (): string[] => [...new Set(interact.values())];
  Object.assign(window, {
    __clerk: { spend, session: S, rt, openDialog, closeDialog, closeZoom, triggerInteract, interactIds },
  });
}
